module.exports = __webpack_public_path__ + "static/media/tank-fill-red.4371f9af.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/tank-fill-red.png
// module id = 1139
// module chunks = 0